import * as Yup from 'yup';

const campaignStartDate =Yup.string().required('Start date is required');

export default campaignStartDate;
